import { helpers } from "@vuelidate/validators";

export const specialCharactersValidator = helpers.withMessage(
  "Special characters are not allowed",
  helpers.regex(/^[a-zA-Z0-9À-ÖØ-öø-įĴ-őŔ-žǍ-ǰǴ-ǵǸ-țȞ-ȟȤ-ȳɃɆ-ɏḀ-ẞƀ-ƓƗ-ƚƝ-ơƤ-ƥƫ-ưƲ-ƶẠ-ỿ @._-]*$/)
);

export const lettersAndNumbersValidator = helpers.withMessage(
  "Only letters and numbers allowed",
  helpers.regex(/^[a-zA-Z0-9]*$/)
);

export const numbersValidator = helpers.withMessage("Only numbers are allowed", helpers.regex(/^[0-9]*$/));
